module.exports = require("node-fetch-native");